function injectStyle (ssrContext) {
  require("!!../../../../../../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?minimize!../../../../../../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-bca0cc74\",\"scoped\":true,\"hasInlineConfig\":true}!stylus-loader!../../../../../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Message.vue")
}
var Component = require("!../../../../../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!../../../../../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Message.vue"),
  /* template */
  require("!!../../../../../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-bca0cc74\",\"hasScoped\":true,\"preserveWhitespace\":false}!../../../../../../../../../../../node_modules/vue-loader/lib/template-compiler/preprocessor?engine=pug!../../../../../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Message.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bca0cc74",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/profile/components/info/components/block/components/resultform/components/message/Message.vue
// module id = 4a42868634917a6578fe
// module chunks = 89